import { Component } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, countryActionId, toastError, toastSuccess, serviceTypeId } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { getServiceDeliverableMasterList_action, insertUpdatServiceDeliverableMasterList_action } from "../../../../actions/admin_module_action/master_action/exhibition_master_action/service_deliverable_master_action";
import ExhibitorTopMenu from "../../../../common_components/exhibitor_module_topmenu";


class ServiceDeliverableMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            list: [],
            SDList: [],
            MainServiceDeliverablesID: '',
            isOpen: false,
            toAdd: false,
            ExhibitionID: '',
            mainList: [],
            MainServiceID: '',
            IsActive: '',
            loginAccesslist: [],
        }
        this.onDeleteRow = this.onDeleteRow.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.onAddRow = this.onAddRow.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getSDMasterList = this.getSDMasterList.bind(this)
        this.onMainServiceDeliverablesNameChange = this.onMainServiceDeliverablesNameChange.bind(this)
        this.insertUpdateServiceDeliverablesMasterList = this.insertUpdateServiceDeliverablesMasterList.bind(this)
        // this.onPriceINRChange = this.onPriceINRChange.bind(this)
        // this.onPriceUSDChange = this.onPriceUSDChange.bind(this)
        // this.onDateChange = this.onDateChange.bind(this)
        this.onNameChange = this.onNameChange.bind(this)
    }

    componentDidMount() {
        this.setState({ loginAccesslist: JSON.parse(sessionStorage.getItem('loginDataSS'))['loginAccesslist'] })
        this.getFillList(serviceTypeId, '', '', '', '', '');
        this.setState({
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        })
        setTimeout(() => {

            this.getSDMasterList()
        }, 200);
    }

    onAddRow(e) {
        e.preventDefault();
        // console.log(this.state.listLength)
        const { list } = this.state
        var id = list.length + 1
        var map = {
            MainServiceDeliverablesName: "",
            // Mandatory: 0,
            MainServiceID: '',
            MainServiceDeliverablesID: null,
            isAdd: true,
            isUpdate: true,
            isdelete: false
        }
        list.push(map)
        this.setState({ list: list, })
        // console.log(this.state.StallSizeList)
    }

    // Get Fill Lists
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // country list
                    if (actionID === serviceTypeId) {
                        console.log("country data", data.data)
                        this.setState({ SDList: data.data, isLoading: false })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    getSDMasterList() {
        this.setState({ isLoading: true })
        this.props.getServiceDeliverableMasterList_action(this.state.ExhibitionID, this.state.MainServiceID, this.state.IsActive)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        if (data.data[0].length > 0) {
                            data.data[0].map(element => {
                                element.isUpdate = false
                                element.isAdd = false
                            })
                            console.log(data.data)
                            var temData = []
                            data.data[0].length > 0 && data.data[0].map(item => {
                                var obj = { ...item }
                                temData.push(obj)
                            })
                            this.setState({
                                list: data.data[0],
                                mainList: temData.length > 0 ? [...temData] : [],
                                isAdd: false
                            })
                        } else {
                            this.setState({
                                list: [{
                                    MainServiceDeliverablesID: null,
                                    MainServiceDeliverablesName: "",
                                    MainServiceID: null,
                                }],
                                mainList: [],
                                isAdd: false
                            })
                        }
                    }
                    else {
                        this.setState({ isAdd: true })
                    }
                    this.setState({ isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    insertUpdateServiceDeliverablesMasterList() {
        const { list, ExhibitionID, mainList } = this.state
        console.log(list, mainList, '////')

        // var finalList = []
        // for (var i = 0; i < list.length; i++) {
        //     if (list[i].isUpdate == true) {
        //         finalList.push(list[i])
        //     }
        // }
        var passOn = false
        if (list.length == 1 && mainList.length != 0) {
            if (list[0].MainServiceDeliverablesID == null && list[0].MainServiceDeliverablesName == '' && list[0].MainServiceID == null) {
                passOn = true
            }
        }

        var inputValidate = false
        var inputValidateIsSame = false
        for (var i = 0; i < list.length; i++) {
            if (list[i].MainServiceID == '' || list[i].MainServiceID == null) {
                inputValidate = true
                break
            }
            if (list[i].MainServiceDeliverablesName == '' || list[i].MainServiceDeliverablesName == null) {
                inputValidate = true
                break
            }
        }
        for (var i = 0; i < list.length; i++) {
            for (var j = 0; j < list.length; j++) {
                if (i != j) {
                    if (list[i].MainServiceID == list[j].MainServiceID) {
                        // console.log(list[i].MainServiceID, list[j].MainServiceID)
                        if (list[i].MainServiceDeliverablesName.trim() == list[j].MainServiceDeliverablesName.trim()) {
                            inputValidateIsSame = true
                            inputValidate = true
                        }
                    }
                }
            }
        }
        // if () {

        // }
        if (inputValidate == true && !passOn) {
            inputValidateIsSame ?
                toastError("Deliverables cannot be same for same Services") :
                toastError("Please Fill all the fields")
        }
        else {
            for (var i = 0; i < list.length; i++) {
                if (list[i].MainServiceDeliverablesID != null && list[i].MainServiceDeliverablesID != '') {
                    // if (isID) {
                    list[i].ActionID = 2
                    // } else {
                    //     list[i].ActionID = 3
                    // }
                } else {
                    list[i].ActionID = 1
                }
                // var obj = finalList[i]
                // delete obj.isAdd
                // delete obj.isUpdate
            }
            for (var j = 0; j < mainList.length; j++) {
                var isID = false
                for (var i = 0; i < list.length; i++) {
                    if (list[i].MainServiceDeliverablesID == mainList[j].MainServiceDeliverablesID) {
                        isID = true
                    }
                }
                if (!isID) {
                    mainList[j].ActionID = 3
                    list.push(mainList[j])
                }
            }
            this.setState({ isLoading: true })
            this.props.insertUpdatServiceDeliverableMasterList_action(ExhibitionID, list)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false })
                        this.getSDMasterList()
                        toastSuccess("update successfully")
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    onDelete(i) {
        const { list } = this.state
        // var MainServiceDeliverablesID = list[i].MainServiceDeliverablesID
        // if (list[i].isAdd == true) {
        //     list.splice(i, 1)
        //     this.setState({ list: list })
        // }
        // else {
        // this.setState({ isLoading: true })
        this.setState({ MainServiceDeliverablesID: i })
        this.setState({ isOpen: true })
        // }
    }

    onDeleteRow() {
        const { MainServiceDeliverablesID, list, ExhibitionID } = this.state
        // this.props.deleteManualformsMaster_action(ExhibitionID, MainServiceDeliverablesID)
        //     .then((data) => {
        //         if (data.error != 1) {
        this.setState({ isOpen: false })
        // this.setState({ isLoading: false, list: [] })
        // var id = ''
        // list.map((item, i) => {
        //     if (item.MainServiceDeliverablesID == MainServiceDeliverablesID) {
        //         id = i
        //     }
        // })
        list.splice(MainServiceDeliverablesID, 1)
        this.setState({ list: list })
        setTimeout(() => {
            if (list.length == 0) {
                this.setState({
                    list: [{
                        MainServiceDeliverablesID: null,
                        MainServiceDeliverablesName: "",
                        MainServiceID: null,
                    }],
                })
            }
        }, 200);
        this.setState({ isLoading: false })
        // toastSuccess("delete successfully")
        //         this.getSDMasterList()
        //     }
        //     else {
        //         this.setState({ isLoading: false })
        //         toastError(data.msg)
        //     }
        // })
        // .catch((err) => {
        //     console.log(err)
        // })
    }

    // onPriceINRChange(e, ID) {
    //     e.preventDefault()
    //     const { list } = this.state
    //     list.map((data, i) => {
    //         if (ID == i) {
    //             data.PriceINR = parseFloat(e.target.value)
    //             data.isUpdate = true
    //         }
    //     })
    //     setTimeout(() => {
    //         console.log(list)
    //         this.setState({ list: list })
    //     }, 200);
    // }

    // onPriceUSDChange(e, ID) {
    //     e.preventDefault()
    //     const { list } = this.state
    //     list.map((data, i) => {
    //         if (ID == i) {
    //             data.PriceUSD = parseFloat(e.target.value)
    //             data.isUpdate = true
    //         }
    //     })
    //     setTimeout(() => {
    //         console.log(list)
    //         this.setState({ list: list })
    //     }, 200);
    // }

    // onDateChange(e, ID) {
    //     // e.preventDefault()
    //     const { list } = this.state
    //     console.log(e)
    //     list.map((data, i) => {
    //         if (ID == i) {
    //             data.Deadline = new Date(moment(e, 'DD-MM-YYYY').format('YYYY-MM-DD'))
    //             data.isUpdate = true
    //         }
    //     })
    //     setTimeout(() => {
    //         console.log(list)
    //         this.setState({ list: list })
    //     }, 200);
    // }

    onMainServiceDeliverablesNameChange(e, ID) {
        // e.preventDefault()
        const { list } = this.state
        // console.log(e)
        list.map((data, i) => {
            if (ID == i) {
                data.MainServiceDeliverablesName = e.target.value
                data.isUpdate = true
            }
        })
        this.setState({ list: list })
    }

    getWriteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '64');
        if (moduleAccess) {
            return moduleAccess.WriteAccess;
        } else {
            return false
        }
        return false;
    }

    getUpdateAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '64');
        if (moduleAccess) {
            return moduleAccess.UpdateAccess;
        } else {
            return false
        }
        return false;
    }

    getDeleteAccess() {
        const { loginAccesslist } = this.state
        const moduleAccess = loginAccesslist.find((item) => item.ModuleID == '64');
        if (moduleAccess) {
            return moduleAccess.DeleteAccess;
        } else {
            return false
        }
        return false;
    }

    onNameChange(e, ID) {
        // e.preventDefault()
        const { list } = this.state
        console.log(e.target.value)
        // var checkForm = false
        // for (var i = 0; i < list.length; i++) {
        //     if (parseInt(e.target.value) == list[i].ServiceID) {
        //         // checkForm = true
        //         break
        //     }
        // }
        // if (checkForm == true) {
        //     toastError("Manual form already select in list")
        // }
        // else {
        list.map((data, i) => {
            if (ID == i) {
                data.MainServiceID = e.target.value != '' && e.target.value != null ? parseInt(e.target.value) : ''
                data.isUpdate = true
            }
        })
        // }
        this.setState({ list: list })
    }

    clearValue() {
        this.setState({
            MainServiceID: '',
            IsActive: '',
        }, () => this.getSDMasterList())
    }

    render() {
        const { isLoading, isOpen, mainList, list, SDList, MainServiceID, IsActive } = this.state
        console.log(mainList, list)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                {
                    JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                        <ExhibitorHeader /> : <HeaderWithLogo />
                }
                <div
                    //  className="with-dr-container com-height"
                    className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"}
                >
                    <div className="main-container">
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorDrawer /> : <AdminDrawer />
                        }
                        {
                            JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ?
                                <ExhibitorTopMenu /> : null
                        }

                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Deliverables Services</h6>
                            </div>
                        </div>
                    </div>
                    <div className="admin-top-space p-2">
                        <div className='row m-0'>
                            <div className='col-md-3'>
                                <label>Service</label>
                                <select
                                    className="form-control"
                                    value={MainServiceID}
                                    onChange={(e) => this.setState({ MainServiceID: e.target.value })}
                                >
                                    <option value={''}>Select</option>
                                    {SDList.length > 0 &&
                                        SDList.map((data) => (
                                            <option key={data.ServiceID} value={data.ServiceID}>
                                                {data.Name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className='col-md-3'>
                                <label>Status</label>
                                <select
                                    className="form-control"
                                    value={IsActive}
                                    onChange={(e) => this.setState({ IsActive: e.target.value })}
                                >
                                    <option value={''}>Select</option>
                                    <option value={1}>Active</option>
                                    <option value={0}>InActive</option>

                                </select>
                            </div>
                            <div className="col-md-6 mb-3 text-end">
                                <label></label>
                                <button
                                    type="button"
                                    className="btn btn-aqua mt-2"
                                    onClick={(e) => this.getSDMasterList()}
                                >
                                    Search
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-gray py-1 mt-2 ms-2"
                                    onClick={(e) => this.clearValue()}
                                >
                                    Clear
                                </button>
                            </div>
                        </div>
                        {/* <div style={{ float: 'right' }} >
                        <button type="button" class="btn btn-primary rounded-0" onClick={(e) => this.onAddRow(e)}>
                            Add Deliverable
                        </button>
                    </div> */}
                        <div class="table-responsive px-1 sticky-table-wrapper service-list-grid mx-2">
                            <table class="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
                                <thead class="table-light">
                                    <tr>
                                        <th className="text-left" style={{ width: '35%' }}>Services<span style={{ color: 'red' }}>*</span></th>
                                        <th className="text-left">Deliverables<span style={{ color: 'red' }}>*</span></th>
                                        {/* <th className="text-center">Price (INR)</th> */}
                                        {/* <th className="text-center">Price (USD)</th> */}
                                        {/* <th className="text-center">Approval</th> */}
                                        <th style={{ width: '60px' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        list.length > 0 ? <>{
                                            list.map((data, i) => (
                                                data.ActionID != 3 &&
                                                <tr key={i}>
                                                    <td>
                                                        <select
                                                            className="form-control"
                                                            value={data.MainServiceID}
                                                            onChange={(e) => this.onNameChange(e, i)}
                                                        >
                                                            <option value={''}>Select</option>
                                                            {SDList.length > 0 &&
                                                                SDList.map((data) => (
                                                                    <option key={data.ServiceID} value={data.ServiceID}>
                                                                        {data.Name}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </td>
                                                    {/* <td>
                                                    <DatePicker
                                                        selected={data.Deadline != null && data.Deadline != '' ? new Date(data.Deadline) : null}
                                                        dateFormat={"dd-MM-yyyy"} className="form-control"
                                                        onChange={(e) => this.onDateChange(e, i)}
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        placeholderText="dd-mm-yyyy"
                                                        dayClassName={() => "example-datepicker-day-class"}
                                                        popperClassName="example-datepicker-class" />
                                                </td> */}
                                                    {/* <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder=""
                                                        value={data.PriceINR}
                                                        // disabled={true}
                                                        onChange={(e) => this.onPriceINRChange(e, i)}
                                                    />
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder=""
                                                        value={data.PriceUSD}
                                                        // disabled={true}
                                                        onChange={(e) => this.onPriceUSDChange(e, i)}
                                                    />
                                                </td> */}
                                                    {/* <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        placeholder=""
                                                        checked={data.isDirectApproval}
                                                        // disabled={true}
                                                        onChange={(e) => this.onCheckboxChange(e, i)}
                                                    />Checked for Direct Approval
                                                </td> */}
                                                    <td style={{ textAlign: 'center' }}>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            required=""
                                                            value={data.MainServiceDeliverablesName}
                                                            onChange={(e) => this.onMainServiceDeliverablesNameChange(e, i)}
                                                        />
                                                    </td>
                                                    <td style={{ textAlign: 'center' }}>
                                                        {list.length - 1 == i &&
                                                            <i class="fa fa-plus mr-2"
                                                                onClick={(e) => this.onAddRow(e)}
                                                            />
                                                        }
                                                        {this.getDeleteAccess() && <i className="fa fa-trash-o ms-2 grid-icon"
                                                            onClick={() => this.onDelete(i)}
                                                        />}
                                                    </td>

                                                </tr>
                                            ))}
                                        </> :
                                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                    }
                                </tbody>
                            </table>
                            <div style={{ float: 'right' }} >
                                <button disabled={list.length == 0 || !this.getWriteAccess()} type="button" class="btn btn-aqua rounded-1 mt-3 ms-2"
                                    onClick={(e) => this.insertUpdateServiceDeliverablesMasterList(e)}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div >
                </div >
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog">
                        <div className="modal-content confirm-logout">
                            {/* <div class="modal-header text-right p-2">
                                <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button>
                            </div> */}
                            <div class="modal-body">
                                <div class="row">
                                    <h5 class="modal-title">Do you really want to delete this record?</h5>
                                </div>
                            </div>
                            <div class="modal-footer p-1">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.onDeleteRow()}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getServiceDeliverableMasterList_action, insertUpdatServiceDeliverableMasterList_action })(ServiceDeliverableMaster));